const PUBLIC_PACKAGES_BASE_PATH = '/abbonamenti'
const LEGACY_PUBLIC_PACKAGES_BASE_PATH = '/pacchetti'
const DASHBOARD_PACKAGES_BASE_PATH = '/dashboard/abbonamenti'
const LEGACY_DASHBOARD_PACKAGES_BASE_PATH = '/dashboard/pacchetti'

const getPublicPackageRoute = (slug = '') => {
  const normalizedSlug = String(slug || '').replace(/^\/+|\/+$/g, '')

  return normalizedSlug
    ? `${PUBLIC_PACKAGES_BASE_PATH}/${normalizedSlug}`
    : PUBLIC_PACKAGES_BASE_PATH
}

const getLegacyPublicPackageRoute = (slug = '') => {
  const normalizedSlug = String(slug || '').replace(/^\/+|\/+$/g, '')

  return normalizedSlug
    ? `${LEGACY_PUBLIC_PACKAGES_BASE_PATH}/${normalizedSlug}`
    : LEGACY_PUBLIC_PACKAGES_BASE_PATH
}

const getDashboardPackageRoute = (slug = '') => {
  const normalizedSlug = String(slug || '').replace(/^\/+|\/+$/g, '')

  return normalizedSlug
    ? `${DASHBOARD_PACKAGES_BASE_PATH}/${normalizedSlug}`
    : DASHBOARD_PACKAGES_BASE_PATH
}

const getLegacyDashboardPackageRoute = (slug = '') => {
  const normalizedSlug = String(slug || '').replace(/^\/+|\/+$/g, '')

  return normalizedSlug
    ? `${LEGACY_DASHBOARD_PACKAGES_BASE_PATH}/${normalizedSlug}`
    : LEGACY_DASHBOARD_PACKAGES_BASE_PATH
}

const getPublicPackageCustomizationRoute = (slug = '') =>
  `${getPublicPackageRoute(slug)}/personalizza-il-pacchetto`

const getDashboardPackageCustomizationRoute = (slug = '') =>
  `${getDashboardPackageRoute(slug)}/personalizza-il-pacchetto`

const getPublicPackagePaymentRoute = (slug = '') =>
  `${getPublicPackageRoute(slug)}/pagamento`

const getDashboardPackagePaymentRoute = (slug = '') =>
  `${getDashboardPackageRoute(slug)}/pagamento`

const getPublicPackageSuccessRoute = (slug = '') =>
  `${getPublicPackagePaymentRoute(slug)}/grazie`

const getDashboardPackageSuccessRoute = (slug = '') =>
  `${getDashboardPackagePaymentRoute(slug)}/grazie`

module.exports = {
  PUBLIC_PACKAGES_BASE_PATH,
  LEGACY_PUBLIC_PACKAGES_BASE_PATH,
  DASHBOARD_PACKAGES_BASE_PATH,
  LEGACY_DASHBOARD_PACKAGES_BASE_PATH,
  getPublicPackageRoute,
  getLegacyPublicPackageRoute,
  getDashboardPackageRoute,
  getLegacyDashboardPackageRoute,
  getPublicPackageCustomizationRoute,
  getDashboardPackageCustomizationRoute,
  getPublicPackagePaymentRoute,
  getDashboardPackagePaymentRoute,
  getPublicPackageSuccessRoute,
  getDashboardPackageSuccessRoute,
}